import { render, staticRenderFns } from "./BodyChat.vue?vue&type=template&id=616b05d5"
import script from "./BodyChat.vue?vue&type=script&lang=js"
export * from "./BodyChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports